var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileGreenCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1C0.5 0.447716 0.947715 0 1.5 0H6.5L6.5 4C6.5 4.55228 6.94772 5 7.5 5L11.5 5L11.5 9.03095C10.7488 9.12463 10.0622 9.42662 9.5 9.87731V9H4.9V10H9.35417C9.03018 10.286 8.75287 10.6236 8.53513 11H4.9V12H8.12602C8.04375 12.3196 8 12.6547 8 13C8 13.3453 8.04375 13.6804 8.12602 14L1.5 14C0.947716 14 0.5 13.5523 0.5 13V1ZM3.7 7H2.5V8H3.7V7ZM9.5 7H4.9V8H9.5V7ZM3.7 9H2.5V10H3.7V9ZM2.5 11H3.7V12H2.5V11ZM11.0172 4L7.5 4V0.482842C7.5 0.304661 7.71543 0.215428 7.84142 0.34142L11.1586 3.65858C11.2846 3.78457 11.1953 4 11.0172 4ZM14.005 10.755L11.5 13.26L9.99498 11.755L9.00502 12.745L11.005 14.745L11.5 15.2399L11.995 14.745L14.995 11.745L14.005 10.755Z",
    fill: "#14870A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileGreenCheck);
export default __webpack_public_path__ + "static/media/file_green_check.41a2a7df.svg";
export { ForwardRef as ReactComponent };